import { audiobook } from "@/mocks/home";

export default function AudiobookSection() {
  return (
    <section id="audiobook" className="w-full border-b border-background-200 bg-secondary-950">
      <div className="mx-auto w-full max-w-7xl px-4 py-14 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-[0.85fr_1.15fr] lg:gap-14">
          <div>
            <span className="flex items-center gap-2 text-xs font-label tracking-wide text-accent-400">
              <i className="ri-headphone-line" />
              有声书
            </span>
            <h2 className="mt-2 font-heading text-2xl font-bold text-background-50 md:text-3xl">
              闭上眼睛，也能把故事听完
            </h2>
            <p className="mt-3 max-w-md text-sm leading-7 text-background-300">
              完整 42 集有声演播，与文字版章节一一对应。适合通勤、睡前收听，逐集更新不掉队。
            </p>

            <div className="mt-6 overflow-hidden rounded-lg border border-secondary-800 bg-secondary-900">
              <div className="h-64 w-full md:h-72">
                <img
                  src={audiobook.cover}
                  alt="善良的女秘书有声书封面"
                  title="善良的女秘书 有声书"
                  className="h-full w-full object-cover object-top"
                />
              </div>
              <div className="flex items-center justify-between gap-4 p-4">
                <div className="min-w-0">
                  <p className="truncate font-heading text-sm font-bold text-background-50">
                    正在播放：第 1 集《入职第一天》
                  </p>
                  <p className="mt-1 text-xs font-label text-background-400">
                    演播 {audiobook.narrator} · 共 {audiobook.totalEpisodes} 集 · {audiobook.totalHours}
                  </p>
                </div>
                <button
                  type="button"
                  aria-label="播放"
                  className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-accent-500 text-background-50 transition-colors hover:bg-accent-600"
                >
                  <i className="ri-play-fill text-xl" />
                </button>
              </div>
            </div>
          </div>

          <div>
            <div className="flex items-center justify-between border-b border-secondary-800 pb-3">
              <span className="text-sm font-label text-background-200">剧集目录</span>
              <span className="text-xs font-label text-background-400">
                已更新 {audiobook.episodes.length} / {audiobook.totalEpisodes} 集
              </span>
            </div>

            <ul className="mt-2 divide-y divide-secondary-800">
              {audiobook.episodes.map((ep, i) => (
                <li
                  key={ep.no}
                  className="group flex items-center gap-4 py-3.5 transition-colors hover:bg-secondary-900"
                >
                  <button
                    type="button"
                    aria-label={`播放第${ep.no}集`}
                    className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-full transition-colors ${
                      i === 0
                        ? "bg-accent-500 text-background-50"
                        : "border border-secondary-700 text-background-200 group-hover:border-accent-500 group-hover:text-accent-400"
                    }`}
                  >
                    <i className={i === 0 ? "ri-pause-fill" : "ri-play-fill"} />
                  </button>
                  <div className="min-w-0 flex-1">
                    <p className="truncate text-sm font-medium text-background-50">
                      <span className="mr-2 font-label text-background-400">
                        EP {String(ep.no).padStart(2, "0")}
                      </span>
                      {ep.title}
                    </p>
                  </div>
                  <span className="shrink-0 font-label text-xs tabular-nums text-background-400">
                    {ep.duration}
                  </span>
                </li>
              ))}
            </ul>

            <button
              type="button"
              className="mt-5 inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-secondary-700 px-5 py-2.5 text-sm font-label text-background-100 transition-colors hover:border-accent-500 hover:text-accent-400"
            >
              <i className="ri-list-unordered" />
              查看全部 42 集
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}